var _defs, _rect, _path, _path2, _path3, _path4, _g, _rect2, _rect3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path22, _rect13, _rect14;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFreeAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 196.75 165.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.j,.k{fill:#fff;}.b{fill:#5badff;}.c,.g,.i{fill:#114374;}.c{opacity:0.2;}.d{fill:#0083e8;}.e{opacity:0.6;}.f{opacity:0.1;}.h{fill:#1df3ce;}.i,.j{opacity:0.5;}.k{opacity:0.3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "free-account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 55.51,
    width: 107,
    height: 143
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M928.9,3295.42v49.69c0,6.75-9.72,12.23-21.71,12.23s-21.71-5.48-21.71-12.23v-49.69",
    transform: "translate(-865.49 -3224.23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M885.47,3295.42v49.69c0,6.75,9.72,12.23,21.71,12.23v-62.2Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M885.47,3295.82c0-6.75,9.72-12.23,21.71-12.23s21.71,5.48,21.71,12.23v-0.17c0,6.75-9.72,12.23-21.71,12.23s-21.71-5.48-21.71-12.23v0.17Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M885.47,3295.82c0-6.75,9.72-12.23,21.71-12.23s21.71,5.48,21.71,12.23v-0.17c0,6.75-9.72,12.23-21.71,12.23s-21.71-5.48-21.71-12.23v0.17Z",
    transform: "translate(-865.49 -3224.23)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 997.66,
    y: 3311.63,
    width: 72.77,
    height: 12.32,
    transform: "translate(-3219.4 -680.23) rotate(-59.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 998.15,
    y: 3354.49,
    width: 21.93,
    height: 12.32,
    transform: "translate(-3268.76 -680.84) rotate(-59.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M992.21,3384.76c-0.19,1.26-.33,2.39-0.44,3.36a1.32,1.32,0,0,0,2.05,1.24c0.8-.58,1.72-1.26,2.73-2.07Z",
    transform: "translate(-865.49 -3224.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M996.56,3387.29a50.53,50.53,0,0,0,12.37-14.06L998.31,3367a50.39,50.39,0,0,0-6.1,17.71Z",
    transform: "translate(-865.49 -3224.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1022.45,3354.43a1.12,1.12,0,0,1-1.53.4l-12.49-7.32c-0.53-.31-0.32-1-0.32-1.53h0c0-.53.91-0.71,1.44-0.4l12.54,7.32a1.11,1.11,0,0,1,.38,1.53h0Z",
    transform: "translate(-865.49 -3224.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1060.77,3290a1.66,1.66,0,0,1-2.27.6l-12.88-7.49a1.66,1.66,0,0,1-.6-2.27h0a1.66,1.66,0,0,1,2.27-.6l12.88,7.49a1.66,1.66,0,0,1,.6,2.27h0Z",
    transform: "translate(-865.49 -3224.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1033.13,3288.18a5.09,5.09,0,0,1,7-1.84l0.49,0.29,3.33,1.94-1.69,2.9-2.89-1.68-0.89-.56a1.77,1.77,0,0,0-2.42.64l-0.5.86-11,18.93,1,0.59a2.18,2.18,0,0,1,.79,3l-0.06.1a2.18,2.18,0,0,1-3,.79l-2-1.18a2.18,2.18,0,0,1-.79-3l0,0,0-.05,11.92-20.5Z",
    transform: "translate(-865.49 -3224.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1051.32,3282.51l5.72-9.84a2.61,2.61,0,0,1,3.57-.94l0.33,0.19a2.61,2.61,0,0,1,.94,3.57l-5.72,9.84",
    transform: "translate(-865.49 -3224.23)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 997.19,
    y: 3307.63,
    width: 72.77,
    height: 12.31,
    transform: "translate(-3216.09 -683.01) rotate(-59.82)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 997.68,
    y: 3350.49,
    width: 21.93,
    height: 12.32,
    transform: "translate(-3265.59 -683.02) rotate(-59.82)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M991.74,3380.76c-0.19,1.26-.33,2.38-0.44,3.36a1.32,1.32,0,0,0,2.05,1.24c0.8-.58,1.72-1.26,2.73-2.07Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M996.09,3383.29a50.56,50.56,0,0,0,12.36-14.07L997.83,3363a50.39,50.39,0,0,0-6.09,17.71Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1022,3350.43a1.12,1.12,0,0,1-1.53.4l-12.49-7.32a1.18,1.18,0,0,1-.32-1.53,1,1,0,0,1,1.44-.4l12.54,7.32a1.11,1.11,0,0,1,.38,1.53h0Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1060.3,3286a1.66,1.66,0,0,1-2.27.6l-12.88-7.49a1.66,1.66,0,0,1-.6-2.27h0a1.66,1.66,0,0,1,2.27-.6l12.88,7.49a1.66,1.66,0,0,1,.6,2.27h0Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1032.66,3284.19a5.09,5.09,0,0,1,7-1.85l0.49,0.29,3.33,1.94-1.69,2.9-2.89-1.68-0.89-.55a1.77,1.77,0,0,0-2.42.64l-0.5.86-11,18.93,1,0.59a2.18,2.18,0,0,1,.79,3l-0.06.1a2.18,2.18,0,0,1-3,.79l-2-1.18a2.18,2.18,0,0,1-.79-3l0,0,0,0,11.92-20.5Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1032.66,3284.19a5.09,5.09,0,0,1,7-1.85l0.49,0.29,3.33,1.94-1.69,2.9-2.89-1.68-0.89-.55a1.77,1.77,0,0,0-2.42.64l-0.5.86-11,18.93,1,0.59a2.18,2.18,0,0,1,.79,3l-0.06.1a2.18,2.18,0,0,1-3,.79l-2-1.18a2.18,2.18,0,0,1-.79-3l0,0,0,0,11.92-20.5Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1050.85,3278.51l5.72-9.84a2.61,2.61,0,0,1,3.57-.94l0.33,0.19a2.61,2.61,0,0,1,.94,3.57l-5.72,9.84",
    transform: "translate(-865.49 -3224.23)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1050.85,3278.51l5.72-9.84a2.61,2.61,0,0,1,3.57-.94l0.33,0.19a2.61,2.61,0,0,1,.94,3.57l-5.72,9.84",
    transform: "translate(-865.49 -3224.23)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M996.09,3383.29a50.56,50.56,0,0,0,12.36-14.07L997.83,3363a50.39,50.39,0,0,0-6.09,17.71Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M890,3295.19c0-5,7.68-9.06,17.16-9.06s17.16,4.06,17.16,9.06v-0.12c0,5-7.68,9.06-17.16,9.06s-17.16-4.06-17.16-9.06v0.13Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M878.8,3309.89a13.31,13.31,0,1,0,13.31,13.31A13.31,13.31,0,0,0,878.8,3309.89Zm0,20a6.71,6.71,0,1,1,6.71-6.71A6.71,6.71,0,0,1,878.8,3329.9Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M939.7,3255.9c0-4.64,2.59-7.6,6.16-7.6,2.79,0,4.61,1.58,5.36,4.53l-1.36.32c-0.7-2.43-1.83-3.55-4-3.55-2.55,0-4.72,2.09-4.72,6.24s1.93,6.5,4.76,6.5c2.47,0,4.11-1.73,4.09-4.72H946.4v-1.22h4.94v6.94h-1.28v-2.25h0a4.49,4.49,0,0,1-4.27,2.53C941.89,3263.62,939.7,3260.33,939.7,3255.9Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M954.84,3248.58h4.94c3.29,0,5.12,1.4,5.12,4,0,2.39-1.4,3.59-3.53,4l3.73,6.78h-1.6l-3.61-6.62h-3.67v6.62h-1.39v-14.75Zm4.84,6.88c2.43,0,3.81-.7,3.81-2.83s-1.36-2.75-3.83-2.75h-3.43v5.58h3.45Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M972.27,3248.52h1.53l5.22,14.81h-1.47l-1.58-4.55h-6l-1.57,4.55H967Zm3.27,9L973,3250.2h0l-2.53,7.34h5.1Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M985.2,3249.9h-4.76v-1.32h10.94v1.32h-4.76v13.44H985.2V3249.9Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M994.16,3248.58h1.41v14.75h-1.41v-14.75Z",
    transform: "translate(-865.49 -3224.23)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M998.82,3259.71l1.26-.46a4.15,4.15,0,0,0,4.23,3.11c2.21,0,3.65-1,3.65-2.67s-0.74-2.31-3.87-3.31-4.79-1.85-4.79-4.29c0-2.11,1.89-3.79,4.59-3.79a4.93,4.93,0,0,1,5.06,3.39l-1.2.56a3.77,3.77,0,0,0-3.89-2.67c-2,0-3.17,1.06-3.17,2.41,0,1.65,1,2.21,4.09,3.21s4.59,2,4.59,4.39-2.17,4-5.12,4A5.31,5.31,0,0,1,998.82,3259.71Z",
    transform: "translate(-865.49 -3224.23)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 74.48,
    y: 60.77,
    width: 69.06,
    height: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 74.48,
    y: 78.27,
    width: 69.06,
    height: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 74.48,
    y: 95.77,
    width: 69.06,
    height: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 74.48,
    y: 58.77,
    width: 0.56,
    height: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 142.98,
    y: 58.77,
    width: 0.56,
    height: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 74.48,
    y: 76.27,
    width: 0.56,
    height: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 142.98,
    y: 76.27,
    width: 0.56,
    height: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 74.48,
    y: 93.77,
    width: 0.56,
    height: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 142.98,
    y: 93.77,
    width: 0.56,
    height: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M878.8,3309.89a13.31,13.31,0,1,0,13.31,13.31A13.31,13.31,0,0,0,878.8,3309.89Zm0,20a6.71,6.71,0,1,1,6.71-6.71A6.71,6.71,0,0,1,878.8,3329.9Z",
    transform: "translate(-865.49 -3224.23)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 1052.73,
    y: 3276.19,
    width: 2.07,
    height: 5.65,
    transform: "translate(-3172.5 -698.63) rotate(-59.55)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 1000.06,
    y: 3312.48,
    width: 72.05,
    height: 6.09,
    transform: "translate(-3212.6 -696.22) rotate(-59.54)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeAccount);
export default __webpack_public_path__ + "static/media/free-account.69f51a4d3706d882c52f77846c2ab899.svg";
export { ForwardRef as ReactComponent };